import type { Template } from "@/types";

export const PO_05_H1_V4: Template[] = [
    {
        id: "po-05-h1v4-01",
        name: "PO 01 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_01.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 41, y: 238, width: 513, height: 374, rotation: 0, imageRotation: 0 },
            { id: "2", x: 723, y: 155, width: 166, height: 266, rotation: 0, imageRotation: 0 },
            { id: "3", x: 723, y: 429, width: 166, height: 266, rotation: 0, imageRotation: 0 },
            { id: "4", x: 897, y: 155, width: 166, height: 266, rotation: 0, imageRotation: 0 },
            { id: "5", x: 897, y: 429, width: 166, height: 266, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-02",
        name: "PO 02 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_02.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 41, y: 238, width: 513, height: 374, rotation: 0, imageRotation: 0 },
            { id: "2", x: 642, y: 115, width: 365, height: 620, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1015, y: 115, width: 126, height: 202, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1015, y: 325, width: 126, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1015, y: 534, width: 126, height: 201, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-03",
        name: "PO 03 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_03.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 57, y: 133, width: 480, height: 340, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 57, y: 481, width: 155, height: 237, rotation: 0, imageRotation: 0 },
            { id: "3", x: 220, y: 481, width: 155, height: 237, rotation: 0, imageRotation: 0 },
            { id: "4", x: 383, y: 481, width: 154, height: 237, rotation: 0, imageRotation: 0 },
            { id: "5", x: 680, y: 95, width: 425, height: 647, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-04",
        name: "PO 04 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_04.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 51, y: 187, width: 269, height: 475, rotation: 0, imageRotation: 0 },
            { id: "2", x: 328, y: 187, width: 217, height: 155, rotation: 0, imageRotation: 0 },
            { id: "3", x: 328, y: 350, width: 217, height: 312, rotation: 0, imageRotation: 0 },
            { id: "4", x: 653, y: 235, width: 235, height: 380, rotation: 0, imageRotation: 0 },
            { id: "5", x: 896, y: 235, width: 234, height: 380, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-05",
        name: "PO 05 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_05.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 645, y: 187, width: 269, height: 475, rotation: 0, imageRotation: 0 },
            { id: "2", x: 922, y: 187, width: 217, height: 314, rotation: 0, imageRotation: 0 },
            { id: "3", x: 922, y: 509, width: 217, height: 154, rotation: 0, imageRotation: 0 },
            { id: "4", x: 61, y: 235, width: 235, height: 380, rotation: 0, imageRotation: 0 },
            { id: "5", x: 304, y: 235, width: 234, height: 380, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-06",
        name: "PO 06 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_06.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 92, y: 100, width: 409, height: 648, rotation: 0, imageRotation: 0 },
            { id: "2", x: 645, y: 382, width: 493, height: 343, rotation: 0, imageRotation: 0 },
            { id: "3", x: 645, y: 125, width: 159, height: 250, rotation: 0, imageRotation: 0 },
            { id: "4", x: 812, y: 125, width: 159, height: 250, rotation: 0, imageRotation: 0 },
            { id: "5", x: 979, y: 125, width: 159, height: 250, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-07",
        name: "PO 07 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_07.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 28, y: 140, width: 169, height: 281, rotation: 0, imageRotation: 0 },
            { id: "2", x: 28, y: 429, width: 169, height: 280, rotation: 0, imageRotation: 0 },
            { id: "3", x: 205, y: 140, width: 169, height: 281, rotation: 0, imageRotation: 0 },
            { id: "4", x: 205, y: 429, width: 169, height: 280, rotation: 0, imageRotation: 0 },
            { id: "5", x: 382, y: 140, width: 779, height: 568, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-08",
        name: "PO 08 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_08.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 224, width: 565, height: 401, rotation: 0, imageRotation: 0 },
            { id: "2", x: 572, y: 224, width: 240, height: 401, rotation: 0, imageRotation: 0 },
            { id: "3", x: 950, y: 224, width: 240, height: 401, rotation: 0, imageRotation: 0 },
            { id: "4", x: 820, y: 224, width: 122, height: 197, rotation: 0, imageRotation: 0 },
            { id: "5", x: 820, y: 429, width: 122, height: 196, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-05-h1v4-09",
        name: "PO 09 - H1V4",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-05-h1_v4_09.png",
        size: [1190, 850],
        style: {},
        slots: [
            { id: "1", x: 0, y: 224, width: 563, height: 401, rotation: 0, imageRotation: 0 },
            { id: "2", x: 571, y: 224, width: 241, height: 401, rotation: 0, imageRotation: 0 },
            { id: "3", x: 820, y: 224, width: 240, height: 401, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1068, y: 224, width: 122, height: 197, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1068, y: 429, width: 122, height: 196, rotation: 0, imageRotation: 0 }
        ],
    }
];